import { render, staticRenderFns } from "./pbi-wtl-after-sales.page.vue?vue&type=template&id=5e2c447f"
import script from "./pbi-wtl-after-sales.page.vue?vue&type=script&lang=ts"
export * from "./pbi-wtl-after-sales.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports